import React, { useState } from "react";
import { Link } from "react-router-dom";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [moreOpen, setMoreOpen] = useState(false);

    const closeMenu = () => {
        setMenuOpen(false);
        setMoreOpen(false);
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="row menubar align-items-center">

                {/* LOGO */}
                <div className="col-md-4 col-8">
                    <div className="container">
                    <div className="row">
                        <div className="col-3" style={{  margin: '0px !important',display:'flex',alignItems:'center',justifyContent:'end' }}>
                            <img src="./images/twopooja.png" className="logoimage"  alt="logo" />
                        </div>
                        <div className="col-9" style={{ padding: '0px !important', margin: '0px !important',display:'flex',alignItems:'start',justifyContent:'center',flexDirection:'column',gap:'-500px' }}>
                            <span className="templename">
                                Thirunelly Sree Mahavishnu Temple <br /> <span style={{fontSize:'12pt'}}><i>(Under Malabar Devaswom Board)</i></span>
                            </span>
                            <span className="makreri-templename">
                                തിരുനെല്ലി ശ്രീ മഹാവിഷ്ണു ക്ഷേത്രം
                            </span>
                        </div>
                    </div>
                    </div>
                </div>

                {/* HAMBURGER BUTTON */}
                <div className="col-4 d-md-none text-end pe-4">
                    <button
                        className="btn btn-outline-warning humberger"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>
                </div>

                {/* MENU */}
                <div className={`col-md-8 menu-wrapper ${menuOpen ? "show" : ""}`}>
                    <div className="container containeritems">

                        <div className="boxes">
                            <Link to="/" className="menuitems" onClick={closeMenu}>
                                Home
                            </Link>
                        </div>

                        <div className="boxes">
                            <Link to="/History" className="menuitems" onClick={closeMenu}>
                                About Temple
                            </Link>
                        </div>

                        <div className="boxes">
                            <a
                                href="https://booking.thirunellytemple.in/"
                                className="menuitems"
                                onClick={closeMenu}
                            >
                                Online Booking
                            </a>
                        </div>

                        <div className="boxes">
                            <Link to="/Timing" className="menuitems" onClick={closeMenu}>
                                Darsan Time
                            </Link>
                        </div>



                        <div className="boxes">
                            <Link to="/Contact" className="menuitems" onClick={closeMenu}>
                                Contact
                            </Link>
                        </div>
                        {/* MORE DROPDOWN */}
                        <div className="boxes dropdown">
                            <span
                                className="menuitems dropdown-toggle"
                                onClick={() => setMoreOpen(!moreOpen)}
                                style={{ cursor: "pointer" }}
                            >
                                More
                            </span>

                            {moreOpen && (
                                <div className="dropdown-menu-custom">
                                    <Link
                                        to="/Accommodation"
                                        className="dropdown-item"
                                        onClick={closeMenu}
                                    >
                                        Accommodation
                                    </Link>

                                    <Link
                                        to="/Gallery"
                                        className="dropdown-item"
                                        onClick={closeMenu}
                                    >
                                        Gallery
                                    </Link>
                                </div>
                            )}
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default MainMenu;